export function formatMoney(value: number) {
  return `$${value.toFixed(2)}`
}
